module.exports = __webpack_public_path__ + "img/icon7.20489e2a.jpg";